import { Avatar, ListItem, ListItemAvatar, ListItemText } from "@mui/material"
import { allowedCurrencies, paymentOptions } from "../../../../utils/constants";
import { styles } from "../../theme";
import CryptoIcon from "../../../../assets/logo/crypto-white.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { filterCurrencies } from "../../../../utils";
const CurrencyList = ({ payment, handlePaymentMethod }) => {
    const { t } = useTranslation();
    const currencies = useSelector(({ currencies }) => currencies.currencies);
    const [filteredCurrency, setFilteredCurrency] = useState([]);
    useEffect(() => {
        if (currencies.length) {
            const filtered = filterCurrencies(currencies, allowedCurrencies);
            setFilteredCurrency(filtered);
        }
    }, [currencies]);

    const shouldShowOtherCurrencies = !(currencies.length === 1 && filteredCurrency.length === 1);

    return <>

        {
            filteredCurrency?.map(currency => (

                <ListItem
                    key={currency.id}
                    aria-label="tracker"
                    aria-describedby="transfer_method_crypto"
                    style={payment === paymentOptions.crypto ? styles.selected : {}}
                    onClick={(ev) => handlePaymentMethod(ev, paymentOptions.crypto2, currency)}
                >
                    <ListItemAvatar>
                        <Avatar
                            aria-label="tracker"
                            aria-describedby="transfer_method_crypto"
                        >
                            <CryptoIcon
                                aria-label="tracker"
                                aria-describedby="transfer_method_crypto"
                            />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                        primary={`${currency.currency} (${currency.network}) ${t('homePage.withdraw')}`}
                    />
                </ListItem>
            ))
        }
        {shouldShowOtherCurrencies && (
            <ListItem
                aria-label="tracker"
                aria-describedby="transfer_method_crypto"
                style={payment === paymentOptions.crypto ? styles.selected : {}}
                onClick={(ev) => handlePaymentMethod(ev, paymentOptions.crypto3)}
            >
                <ListItemAvatar>
                    <Avatar
                        aria-label="tracker"
                        aria-describedby="transfer_method_crypto"
                    >
                        <CryptoIcon
                            aria-label="tracker"
                            aria-describedby="transfer_method_crypto"
                        />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={'Other currencies'}
                    secondary={'BTC, ETH, etc.'}
                />
            </ListItem>
        )}
    </>
}

export default CurrencyList;